module.exports = __webpack_public_path__ + "static/img/iphone_room6.bf7bf83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room6.png
// module id = zsI9
// module chunks = 0